import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import FrontPageContent from '@/repositories/data/content/FrontPageContent';

export default class FrontPageContentRepository extends BaseCrudRepository<number, FrontPageContent, FrontPageContent> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/front-page-content/');
    }
}
